import * as React from 'react';

import { StarRating } from 'components/StarRating/StarRating';

import { useAppContext } from 'hooks/context/useAppContext';
import { useReview } from 'hooks/review/useReview';

import { TReview } from 'types/review';

import s from './CanvasReviews.module.css';

type TProps = {
  review: TReview;
};

export const CanvasReview = ({ review }: TProps) => {
  const {
    publicUser: { multi_user: isMultiUser },
  } = useAppContext();
  const reviewData = useReview({ review });
  const {
    rating,
    user_name,
    reviewer_name,
    isFullMessageDisplayed,
    showFullMessage,
  } = reviewData;

  return (
    <article className={s.review}>
      <header className={s.header}>
        <StarRating
          value={rating}
          fillColor="var(--text-primary)"
          fillStrokeColor="var(--text-primary)"
          emptyColor="transparent"
          emptyStrokeColor="var(--accent-tertiary)"
        />
        <h3 className={s.providerName}>
          {isMultiUser ? `with ${user_name}` : null}
        </h3>
      </header>
      {reviewData.message.length > 0 && (
        <>
          <blockquote className={s.message}>{reviewData.message}</blockquote>
          {!isFullMessageDisplayed && (
            <button
              type="button"
              className={s.moreButton}
              onClick={showFullMessage}
            >
              Show More
            </button>
          )}
        </>
      )}
      <footer className={s.footer}>{reviewer_name}</footer>
    </article>
  );
};
